function MinimizeIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 56 56'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20 10V16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20H10M46 20H40C38.9391 20 37.9217 19.5786 37.1716 18.8284C36.4214 18.0783 36 17.0609 36 16V10M36 46V40C36 38.9391 36.4214 37.9217 37.1716 37.1716C37.9217 36.4214 38.9391 36 40 36H46M10 36H16C17.0609 36 18.0783 36.4214 18.8284 37.1716C19.5786 37.9217 20 38.9391 20 40V46'
          stroke='currentColor'
          strokeWidth='4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
}

export default MinimizeIcon;
